globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.ComplementaryServicesController = (function(superClass) {

    utils.extend(ComplementaryServicesController, superClass);

    function ComplementaryServicesController() {
        return ComplementaryServicesController.__super__.constructor.apply(this, arguments);
    }

    $.extend(ComplementaryServicesController.prototype, {
        init: function(){
            this.initEvents();

            return ComplementaryServicesController.__super__.init.apply(this, arguments);
        },
        initEvents: function(){
            $('input[type=radio]').on('change', function(){
                if($('.creation-form-steps-content input[type="radio"]').not(':checked').length == $('.creation-form-steps-content input[type="radio"]').length/2){
                    //all checked
                    $(".btn-disabled").hide();
                    $(".btn-not-disabled").show();
                }
            });
        }
    });

    return ComplementaryServicesController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
